
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.387 4.964a3.287 3.287 0 014.649 4.649l-.79.79a.149.149 0 01-.008.008L8.87 19.779a.75.75 0 01-.53.22H4.75a.75.75 0 01-.75-.75V15.66a.75.75 0 01.22-.53L14.387 4.963zm3.325 3.852l.263-.264a1.787 1.787 0 00-2.527-2.527l-.264.263 2.528 2.528zm-3.588-1.467l2.527 2.528-8.054 8.053-2.527-2.527 8.053-8.054zM5.5 15.971l.004-.004-.004.026v-.022zM8.03 18.5h-.022l.026-.005-.004.005z"}})])
          )
        }
      }
    